<header>
  <div class="container">
    <div class="logos">
      <a>
        <img src="{{imgdynamicurl}}/assets/img/dubai-gov-logo.png" />
      </a>
      <a>        
        <img src="{{imgdynamicurl}}/assets/img/emirates-logo.png" />
      </a>
      <a>
        <img src="{{imgdynamicurl}}/assets/img/dewa-logo.png" />
      </a>
    </div>
  </div>
</header>
